module.exports = __webpack_public_path__ + "static/media/bts_boots_170812_003_small.229ca6d0.jpg";